module.exports = __webpack_public_path__ + "img/partner3.1dbf7ed0.png";